(function (ws) {
    'use strict';

    ws.models.productavailable = ws.models.outstandingStock.extend({

        /**
         * Initialize
         */
        initialize: function (options) {
            this.productCode = encodeURIComponent(options.productId);
            this.displayMessage = options.displayMessage;
        },

        /**
         * Return Url
         */
        url: function () {
            return globals.path.api.westcon.viewProductAvailable + this.productCode;
        },

        /**
         * Parsing the response data to template
         * @param {Object} data
         * @returns {{sapavailabilityList: *, futureAvailabilityCount: integer, maxAvailabilityRows: integer}}
         */
        parse: function (data) {
            return {
                sapAvailabilityList: data,
                maxAvailabilityRows: this.getMaxRowCount(data),
                futureAvailabilityCount: this.hasFutureAvailability(data),
                isCustomerInventoryCount: this.hasCustomerStock(data),
                displayMessage: this.displayMessage
            };
        }

    });

})(westcon);
